/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "89f65d28fbe5a85aaa75fea1682a2c33aa1e33fe";
